<template>
    <div class="wushuju" v-if="!disabled && lengths < 1">
        <div class="wuimg">
            <img src="@/assets/zhanwu.png">
        </div>
        <div class="wutext">暂无数据</div>
    </div>
</template>

<script setup>
import { defineProps, onMounted } from 'vue';

const props = defineProps({
    disabled: Boolean,
    lengths: Number,

});

onMounted(() => {
    // console.log('1111111111111111', props.disabled, props.lengths)
})
</script>

<style lang="scss" scoped>
.wushuju {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 3;
    width: 240px;
    height: 270px;
    // background-color: #1787FF;

    img {
        width: 240px;
        height: 240px;

    }

    .wutext {
        margin-top: 19px;
        font-weight: 400;
        font-size: 16px;
        color: rgba(0, 0, 0, 0.85);
        text-align: center
    }

}
</style>